import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';


//README : Use this service for maipulate the new models.WorkflowTemplateNewVM

@Injectable({ providedIn: 'root' })
export class ModelsService {


  constructor() { }

  public getStep(template: models.WorkflowTemplateNewVM, stepCode: string): models.StepNewVM {
    return template.steps.find(el => el.stepCode === stepCode);
  }

  public getCard(template: models.WorkflowTemplateNewVM, stepCode: string, cardCode: string): models.CardNewVM {
    return this.getStep(template, stepCode).
      cards.find(el => el.cardCode === cardCode);
  }

  public getField(
    template: models.WorkflowTemplateNewVM,
    stepCode: string,
    cardCode: string,
    fieldName: string): models.FieldNewVM {
    return this.getCard(template, stepCode, cardCode).
      fields.fieldVMs.find(el => el.fieldName === fieldName);
  }

  public getArray(
    template: models.WorkflowTemplateNewVM,
    stepCode: string,
    cardCode: string,
    arrayName: string): models.ArrayNewVM {
    return this.getCard(template, stepCode, cardCode).
      fields.arrayVMs.find(el => el.fieldName === arrayName);
  }

  convertToWorkflowTemplateVM_PM(template: models.WorkflowTemplateNewVM): models.WorkflowTemplateVM_PM {
    const result: models.WorkflowTemplateVM_PM = {} as models.WorkflowTemplateVM_PM;
    result.instance = template.instance?.value;
    //result.needCgaValidation = template.needCgaValidation?.value;
    const isBeneficiaryField = this.getField(template, "StepSender", "SenderQualification", "isBeneficiary");
    const isLegalRepresentativeField =
      this.getField(template, "StepSender", "SenderQualification", "isLegalRepresentative");
    const isLegalRepresentativeValidatedField =
      this.getField(template, "StepSender", "SenderQualification", "isLegalRepresentativeValidated");
    const isServiceOrFuneraryField =
      this.getField(template, "StepSender", "SenderQualification", "isServiceOrFunerary");

    const subscriberNumberField =
      this.getField(template, "StepDeceased", "DeceasedIdentification", "subscriberNumber");

    const nifField =
      this.getField(template, "StepDeceased", "DeceasedIdentification", "NIF");

    result.StepSender = {
      SenderQualification: {
        isBeneficiary: isBeneficiaryField.value,
        isLegalRepresentative: isLegalRepresentativeField.value,
        isServiceOrFunerary: isServiceOrFuneraryField.value
      }
    } as models.StepSender;

    result.StepDeceased = {
      DeceasedIdentification: {
        subscriberNumber: subscriberNumberField.value,
        NIF: nifField.value
      }
    } as models.StepDeceased;

    return result;
  }

  public getTemplateTransformed(template: models.WorkflowTemplateNewVM): models.WorkflowTemplateVM_PM{
    const result: models.WorkflowTemplateVM_PM = {} as models.WorkflowTemplateVM_PM;
    // deal with template properties
    for (const prop in template) {
      if (template[prop].property !== undefined && template[prop].property !== 'mandatory') {
        result[prop] = (template[prop].value !== undefined) ? template[prop].value : null;
      }
    }
    // deal with steps
    template.steps.forEach(st => {
      const step: models.Step = {} as models.Step;
      // deal with step properties
      for (const prop in st) {
        if (!Array.isArray(st[prop])) {
          //step[prop] = st[prop];
        }
      }
      // deal with cards
      st.cards.forEach(cd => {
        const card: models.Card = {} as models.Card;
        // deal with card properties
        for (const prop in cd) {
          if (prop != "fields") {
            //card[prop] = cd[prop];
          }
        }
        // deal with fieldsVMs 
        if (cd.fields.fieldVMs.length > 0) {
          cd.fields.fieldVMs.forEach(fd => {
            const valueString = "";// (fd.property != "string" ? fd.value : "");
            card[fd.fieldName] = fd.value === undefined ? valueString : fd.value;
             

          });
        }
        // deal with arrayVMs
        if (cd.fields.arrayVMs.length > 0) {
          cd.fields.arrayVMs.forEach(arr => {

            card[arr.fieldName] = [];
            let obj = {}
            arr.fieldVMs.forEach(fdd => {
              const valueString = "";// (fdd.property != "string" ? fdd.value : "");
              obj[fdd.fieldName] = fdd.value === undefined ? valueString : fdd.value;
              //  fdd.value : null
                //fdd.property != "string" ? null : "";
            });
            card[arr.fieldName].push(obj);
          });
        }
        step[cd.cardCode] = card;
      });

      result[st.stepCode] = step;
    });
    return result;
  }

  public getEmptyBeneficiary(): models.BeneficiaryListVM {
    const result: models.BeneficiaryListVM = {
      beneficiaryID: null,
      survivalPensionBenefit: null,
      reimbursementFuneralBenefit: null,
      funeralAllowanceBenefit: null,
      deceasedRelationship: null,
      hasLegalRepresentation: null,
      legalRepresentationName: null,
      representationType: null,
      rejectionReason:null,
      SSReceived: null,
      SSDiscounts:null,
      livedWithDeceased: null,
      otherDeceasedRelationship: null,
      funeralExpense: null,
      beneficiaryName: null,
      dateOfBirth: null,
      nationality: null,
      gender: null,
      civilStateDeathDate: null,
      civilState:null,
      identificationDocumentType: null,
      identificationNumberFirst: null,
      identificationNumberLast: null,
      NIF: null,
      NISS: null,
      financialService: null,
      financialServiceLast:null,
      hasIncapacity: null,
      hasSocialPension: null,
      socialPensionDate: null,
      hasJudicialInterdiction: null,
      countryCode: null,
      address: null,
      postalCodeFirst: null,
      postalCodeLast: null,
      postalCodeFull: null,
      postalDesignation: null,
      locality: null,
      telephone: null,
      mobileNumber: null,
      email: null,
      marriageDate: null,
      hasCourtAlimony: null,
      alimonyValueDeathDate: null
      , startDateCohabitation: null,
      hasChargeDeceased: null, monthlyncome: null,
      hasIRSExemption: null,
      scholarSituationDeathDate: null,
      educationLevelDeathDate: null,
      registrationYear: null,
      activeProfessionalSituation: null,
      startDateProfession: null,
      income: null,
      professionalSituation: null,
      bankAccount: null, iban: null,
      isSoleHolder: null,
      coholderName: null,
      additionalObservations: null,
      emailNotification: null,
      personTypologyCode: null,
      personTypology: null,
      irsTableCode: null, irsTable: null,
      revenueTitularityCode: null,
      revenueTitularity: null,
      observations: null,
      desvalorizationPercentage: null,
      entireRatePerOption: null,
      dependentsWithoutDisability: null,
      dependentsWithDisability: null,
      hasNacPT: null,
      entity: null,
      isCertified: null,
      auditKey: null,
      hasNIFPT: null,
      notEditable: null
    }

    return result;
  }
}
